'use client'

import { useTranslations } from 'next-intl'

import { TRoomsSearchParams } from '@/entities/room'
import { cn, Slot, useScrollTopDetector } from '@/shared/lib'
import { Separator } from '@/shared/ui'
import { MobileHeader } from '@/widgets/common'
import { MobileKeywordSearchBar } from '@/widgets/keyword-search-bar'
import { MobileFilterMenuList } from '@/widgets/map-search-filter'

import { AirbridgeEventSender } from '../../lib/airbridge-event-sender'
import { useKeywordSearchParams } from '../../lib/keyword-search-params'
import { useRooms } from '../../model/rooms'
import { MobileOrderFilter } from '../order-filter'
import { MobileRoomList } from '../room-list'

type Props = {
  filters: TRoomsSearchParams
}

export const MobileKeywordSearchPage = ({ filters }: Props) => {
  const t = useTranslations('search_result')

  const { isPageReloading } = useKeywordSearchParams()

  const {
    ref: contentRef,
    isScrolled,
    scrollToTop,
    onScroll: handleContentScroll,
  } = useScrollTopDetector<HTMLDivElement>()

  const { rooms, ref: sentinelRef, airbridgeEvent } = useRooms({ filters })

  return (
    <>
      <AirbridgeEventSender airbridgeEvent={airbridgeEvent} />
      <div
        className={cn(
          isScrolled && 'drop-shadow-[0_0_10px_rgba(0,0,0,0.15)] filter',
        )}
      >
        <MobileHeader.Root>
          <Slot name="left">
            <MobileHeader.Back />
          </Slot>
          <Slot name="title">{t('title')}</Slot>
        </MobileHeader.Root>
        <MobileKeywordSearchBar
          keyword={filters.keyword}
          startDate={filters.startDate}
          endDate={filters.endDate}
          onSearch={scrollToTop}
        />
        <MobileFilterMenuList className="max-w-screen overflow-hidden bg-white py-3" />
      </div>
      <div
        ref={contentRef}
        onScroll={handleContentScroll}
        className="h-0 grow overflow-y-auto overscroll-contain"
      >
        <Separator color="light-gray" size="large" />
        <div className="space-y-4 px-4 py-6">
          <MobileOrderFilter value={filters.sortBy} />
          <MobileRoomList
            isLoading={isPageReloading}
            rooms={rooms}
            sentinelRef={sentinelRef}
          />
        </div>
      </div>
    </>
  )
}
